import { useCalendarNav } from './CalendarContext';

interface CalendarShowMoreProps {
  count: number;
  slotDate: Date;
}

const CalendarShowMore = ({ count, slotDate }: CalendarShowMoreProps) => {
  const { navigateToWeek } = useCalendarNav();

  return (
    <div
      className="pl-1 pr-[2px] py-1 rounded-[2px] cursor-pointer"
      onClick={() => navigateToWeek(slotDate)}
    >
      <span className="txt-small-bold text-fg-primary whitespace-nowrap">
        {count} more
      </span>
    </div>
  );
};

export default CalendarShowMore;
